/**
 * A simple lookup map for role-based dashboard paths.
 * This is faster and more maintainable than a long if/else chain or switch statement.
 */
const ROLE_DASHBOARD_MAP = {
  SUPER_ADMIN: "/admin_dashboard",
  MAKER: "/admin_dashboard",
  CHECKER: "/admin_dashboard",
  ADMIN: "/admin_dashboard",
  ANALYST: "/analyst_dashboard",
  TRADER: "/trader_dashboard",
  BANKING: "/banking",
  COMPANY_ADMIN: "/admin_company_dashboard",
  CONSUMER: "/dashboard",
  GENERATOR: "/dashboard",
};

/**
 * Gets the correct dashboard path for a given user role.
 *
 * @param {string} role - The user's activeRole (e.g., "ADMIN", "TRADER").
 * @returns {string} The corresponding path (e.g., "/admin_dashboard").
 * Returns "/" (home) if the role is not recognized.
 */
const getDashboardPath = (role) => {
  // Log the role for debugging
  console.debug("Getting path for role:", role);

  // Look up the path in the map
  // If the role doesn't exist in the map, default to "/"
  const path = ROLE_DASHBOARD_MAP[role] || "/";

  return path;
};

export default getDashboardPath;
